import { formatDateRange, formatToLocalYMD } from "./utils";

export const DEFAULT_VEHICLE_REPORT_DATA_YEAR = 2025;

const MONTH_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

export function fuelReportMonthKey(year: number, month1To12: number): string {
  return `${year}-${String(month1To12).padStart(2, "0")}`;
}

export function fuelReportQuarterCalendarRange(
  year: number,
  quarter: 1 | 2 | 3 | 4
): { start: Date; end: Date } {
  const startMonth = (quarter - 1) * 3;
  const start = new Date(year, startMonth, 1);
  start.setHours(0, 0, 0, 0);
  const end = new Date(year, startMonth + 3, 0);
  end.setHours(23, 59, 59, 999);
  return { start, end };
}

export function parseQuarterPresetValue(
  value: string
): { year: number; quarter: 1 | 2 | 3 | 4 } | null {
  const m = value.match(/^quarter-(\d{4})-([1-4])$/);
  if (!m) return null;
  return {
    year: parseInt(m[1], 10),
    quarter: parseInt(m[2], 10) as 1 | 2 | 3 | 4,
  };
}

/** Maps context filters to the Period <Select> value in month/quarter mode. */
export function fuelReportPeriodSelectValue(
  filters: { dateFilter?: string; startDate?: string; endDate?: string },
  dataYear: number
): string {
  const df = filters.dateFilter || "";
  if (/^\d{4}-\d{2}$/.test(df)) return df;
  if (df === "custom") {
    if (filters.startDate && filters.endDate) {
      for (const q of [1, 2, 3, 4] as const) {
        const { start, end } = fuelReportQuarterCalendarRange(dataYear, q);
        if (
          filters.startDate === formatToLocalYMD(start) &&
          filters.endDate === formatToLocalYMD(end)
        ) {
          return `quarter-${dataYear}-${q}`;
        }
      }
    }
    return "__custom__";
  }
  return fuelReportMonthKey(dataYear, 1);
}

export function buildMonthOnMonthMenuOptions(year: number) {
  return MONTH_SHORT.map((name, i) => {
    const key = fuelReportMonthKey(year, i + 1);
    const start = new Date(year, i, 1);
    const end = new Date(year, i + 1, 0);
    return {
      value: key,
      label: `${name} ${year} ${formatDateRange(start, end)}`,
    };
  });
}

export function buildQuarterMenuOptions(year: number) {
  return ([1, 2, 3, 4] as const).map((q) => {
    const { start, end } = fuelReportQuarterCalendarRange(year, q);
    return {
      value: `quarter-${year}-${q}`,
      label: `Q${q} ${year} ${formatDateRange(start, end)}`,
    };
  });
}
